export default __webpack_public_path__ + "static/media/google_play_badge.fa5d95ea.svg";